import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';

const DropdownValue = ({ rule, onValueChange }) => (
  <Dropdown
    selection
    options={rule.valueOptions}
    value={rule.selectedValue}
    onChange={(e, data) => onValueChange(rule.instanceId, 'selectedValue', data.value)}
  />
);

DropdownValue.propTypes = {
  rule: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
};

export default DropdownValue;
